import { formatHours } from 'functions/src/util/date/formatHours';

export function getRentalDuration(hoursMin = 1, hoursMax: number) {
  const isRange = hoursMin && hoursMin !== hoursMax;
  const duration = `${
    isRange
      ? `${
          hoursMin < 24 && (hoursMax < 24 || hoursMin % 24 === 0)
            ? `${hoursMin}`
            : formatHours(hoursMin)
        } - `
      : ''
  }${formatHours(hoursMax)}`;
  return duration;
}
